import type { WeatherData } from '../types/weather';

/**
 * Realistic mock weather data — used until a live weather provider is integrated.
 *
 * Venue-specific info (track name, city) is NOT in WeatherData — it comes
 * from the showcase's event/circuit data at render time.
 */
export const mockWeatherData: WeatherData = {
  currentTemp: 84,
  high: 90,
  low: 61,
  condition: 'sunny',
  humidity: 23,
  windSpeed: 9.3,
  windDirection: 'NW',
  windDegrees: 315,
  rainfall: 0,
  rainfallIn: 0,
  hourly: [
    { time: '2 PM', temp: 84, windSpeed: 9.3, windDirection: 45,  windDirLabel: 'NE',  condition: 'sunny' },
    { time: '3 PM', temp: 82, windSpeed: 9.3, windDirection: 15,  windDirLabel: 'N',   condition: 'sunny' },
    { time: '4 PM', temp: 82, windSpeed: 8.5, windDirection: 0,   windDirLabel: 'N',   condition: 'sunny' },
    { time: '5 PM', temp: 81, windSpeed: 7.8, windDirection: 340, windDirLabel: 'NW',  condition: 'cloudy' },
    { time: '6 PM', temp: 80, windSpeed: 6.2, windDirection: 315, windDirLabel: 'NW',  condition: 'cloudy' },
    { time: '7 PM', temp: 78, windSpeed: 5.4, windDirection: 300, windDirLabel: 'WNW', condition: 'cloudy' },
  ],
};
